import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { stringToBoolean } from 'src/app/shared/utils/string-to-boolean.util';

@Component({
  selector: 'app-form-visualizer',
  templateUrl: './form-visualizer.component.html',
  styleUrls: ['./form-visualizer.component.scss']
})
export class FormVisualizerComponent {
  @Input() form: UntypedFormGroup;

  get isInDebugMode() {
    return stringToBoolean(environment.debug);
  }
}
